var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusRejected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.4581 1V12M20.4581 8.8V4.2C20.4581 3.07989 20.4581 2.51984 20.2401 2.09202C20.0483 1.71569 19.7424 1.40973 19.366 1.21799C18.9382 1 18.3782 1 17.2581 1H6.57607C5.11459 1 4.38385 1 3.79364 1.26743C3.27346 1.50314 2.83136 1.88242 2.5193 2.36072C2.16523 2.90339 2.05412 3.62564 1.83189 5.07012L1.30881 8.47012C1.0157 10.3753 0.869152 11.3279 1.15186 12.0691C1.4 12.7197 1.86671 13.2637 2.47198 13.6079C3.16159 14 4.12539 14 6.053 14H6.85806C7.41811 14 7.69814 14 7.91205 14.109C8.10021 14.2049 8.25319 14.3578 8.34907 14.546C8.45806 14.7599 8.45806 15.0399 8.45806 15.6V18.5342C8.45806 19.896 9.56205 21 10.9239 21C11.2487 21 11.5431 20.8087 11.675 20.5119L15.0358 12.9502C15.1886 12.6062 15.265 12.4343 15.3859 12.3082C15.4926 12.1967 15.6238 12.1115 15.769 12.0592C15.9333 12 16.1215 12 16.4979 12H17.2581C18.3782 12 18.9382 12 19.366 11.782C19.7424 11.5903 20.0483 11.2843 20.2401 10.908C20.4581 10.4802 20.4581 9.9201 20.4581 8.8Z",
    stroke: "var(--stroke-0, #DF3822)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusRejected);
export default __webpack_public_path__ + "static/media/status-rejected.97b20328ed6368d1e2ac9ee605ff2759.svg";
export { ForwardRef as ReactComponent };